// Workspace.js
import React from 'react';
import '../styles/Workspace.css'; // external CSS file


const Workspace = () => {
  return (
    <div className="workspace-container">
      <h1>Workspace</h1>
    </div>
  );
};

export default Workspace;
